// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"455":"ca65b960","723":"ca65b960","986":"e70ef019"}[chunkId] + ".chunk.css";
};